import { FadeIn } from "./FadeIn";
import { Quote, ArrowUpRight } from "lucide-react";
import { GOOGLE_MAPS_LINK } from "../constants/contact";

const GoogleG = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const REVIEWS = [
  {
    text: "Sağolsunlar çok hızlı geldiler ve aynı hızda sorunu giderdiler. Çok teşekkürler 🙏",
    source: "Google Müşteri Yorumu",
  },
];

export const Reviews = () => (
  <section id="yorumlar" data-testid="reviews-section" className="relative py-24 sm:py-32">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <FadeIn className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 mb-4">
          Müşteri Yorumları
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight">
          Müşterilerimiz <span className="text-slate-500">ne diyor?</span>
        </h2>
      </FadeIn>

      <div className="mt-14 grid gap-5">
        {REVIEWS.map((r, i) => (
          <FadeIn key={i} delay={0.1}>
            <figure
              data-testid={`review-card-${i}`}
              className="relative rounded-3xl border border-slate-800 bg-[#0F172A] p-8 sm:p-12 overflow-hidden"
            >
              <div
                aria-hidden="true"
                className="absolute -top-24 -right-24 w-[300px] h-[300px] rounded-full bg-amber-500/10 blur-[100px]"
              />
              <Quote className="w-10 h-10 text-amber-500/40 mb-6" fill="currentColor" strokeWidth={0} />
              <blockquote className="relative font-display text-xl sm:text-2xl lg:text-3xl font-medium text-slate-100 leading-snug tracking-tight">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-slate-800 border border-slate-700">
                  <GoogleG className="w-5 h-5" />
                </span>
                <span className="text-sm text-slate-400">{r.source}</span>
              </figcaption>
            </figure>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.2} className="mt-8 text-center">
        <a
          href={GOOGLE_MAPS_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-google-link"
          className="group inline-flex items-center gap-2.5 text-sm font-medium text-slate-300 hover:text-amber-400 transition-colors"
        >
          <GoogleG className="w-4 h-4" />
          Tüm yorumları Google'da görün
          <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </FadeIn>
    </div>
  </section>
);
